var exports = {
  "k": "xa15a2ab7--718064--container",
};

module.exports = exports;
